import React, { FC } from 'react'

interface Props {
  email: string
  firstName: string
  lastName: string
}

const LoggedCustomerView: FC<Props> = ({ firstName, lastName, email }) => (
  <div className="my-1">
    {firstName} {lastName}
    <div className="mt-1">{email}</div>
  </div>
)

export default LoggedCustomerView
